// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__YNZ4z","row":"Node_row__1IAjK","label":"Node_label__3A7g3","footer":"Node_footer__PXiQl"};